/* Product page: option selection, price / availability / pre-order state, gallery lightbox,
   AJAX add to bag, and the concept's to-scale room plan (ported), driven by the real "Rug Types" sizes. */
(function () {
  const root = document.querySelector('[data-rb-product]'); if (!root) return;
  const data = JSON.parse(document.getElementById('rbProductData').textContent);
  const $ = (id) => document.getElementById(id);
  const U = () => window.RBUI;
  const money = (c) => (U() ? U().money(c) : '$' + (c / 100).toFixed(2));
  const groups = [...root.querySelectorAll('[data-option]')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = (window.RBCFG && window.RBCFG.t) || {};
  const tr = (k, fb) => T[k] || fb;

  // ---------- sizes: parse "5' x 8'", "2'7\" x 7'10\"", "8' Round" ----------
  function dims(s) {
    const t = String(s).replace(/[′’]/g, "'").replace(/[″”]/g, '"').replace(/×/g, 'x');
    let m = t.match(/(\d+(?:\.\d+)?)\s*'\s*(?:(\d+)\s*"?)?\s*(?:ft)?\s*round/i);
    if (m) { const d = +m[1] + (+m[2] || 0) / 12; return { w: d, h: d, round: true }; }
    // metric (some translations show "1,22 m x 1,83 m"): convert metres to feet
    m = t.match(/(\d+(?:[.,]\d+)?)\s*m\s*x\s*(\d+(?:[.,]\d+)?)\s*m/i);
    if (m) { const f = (x) => +x.replace(',', '.') / 0.3048; return { w: Math.round(f(m[1]) * 2) / 2, h: Math.round(f(m[2]) * 2) / 2 }; }
    m = t.match(/(\d+(?:[.,]\d+)?)\s*m\s*(?:round|redond|rond)/i);
    if (m) { const d = Math.round((+m[1].replace(',', '.') / 0.3048) * 2) / 2; return { w: d, h: d, round: true }; }
    m = t.match(/(\d+(?:\.\d+)?)\s*'\s*(?:(\d+)\s*"?)?\s*x\s*(\d+(?:\.\d+)?)\s*'\s*(?:(\d+)\s*"?)?/i);
    if (m) return { w: +m[1] + (+m[2] || 0) / 12, h: +m[3] + (+m[4] || 0) / 12 };
    m = t.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (m) return { w: +m[1], h: +m[2] };
    return null;
  }
  const fmt = (ft) => { const f = Math.floor(ft + 1e-6), i = Math.round((ft - f) * 12); return i ? `${f}′${i}″` : `${f}′`; };

  // order size buttons: area rugs small to large, then runners (by width, then length), round, other;
  // with more than one kind, each kind gets a small label so long size lists stay easy to scan
  const TT = (window.RBCFG && window.RBCFG.t) || {};
  const rankOf = (v) => {
    const d = dims(v);
    if (!d) return [3, 0, 0];
    const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h);
    if (d.round) return [2, S, 0];
    if (L / S >= 2.2) return [1, S, L];
    return [0, S * L, 0];
  };
  root.querySelectorAll('[data-size-option]').forEach((g) => {
    const rank = (b) => {
      const d = dims(b.dataset.value);
      if (!d) return [3, 0, 0];
      const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h);
      if (d.round) return [2, S, 0];
      if (L / S >= 2.2) return [1, S, L];
      return [0, S * L, 0];
    };
    const btns = [...g.querySelectorAll('.size')];
    btns.sort((a, b) => { const x = rank(a), y = rank(b); return x[0] - y[0] || x[1] - y[1] || x[2] - y[2]; });
    const kinds = new Set(btns.map((b) => rank(b)[0]));
    const names = [TT.grp_area || 'Area rugs', TT.grp_runner || 'Runners', TT.grp_round || 'Round', TT.grp_other || 'Other sizes'];
    let last = -1;
    btns.forEach((b) => {
      const k = rank(b)[0];
      if (kinds.size > 1 && k !== last) { const h = document.createElement('div'); h.className = 'size-group'; h.textContent = names[k]; g.appendChild(h); last = k; }
      g.appendChild(b);
    });
  });

  // ---------- state ----------
  const selected = () => groups.map((g) => { const on = g.querySelector('.size.on'); return on ? on.dataset.value : null; });
  const findVariant = (opts) => data.variants.find((x) => x.options.every((o, i) => opts[i] == null || o === opts[i]));
  let current = findVariant(selected()) || data.variants[0];

  // sizes that are on sale get a small "-20%" tag on their button, so shoppers can spot the deals
  const onSale = (x) => x && x.available && x.compare > x.price;
  function markSale() {
    if (groups.length !== 1) return;
    groups[0].querySelectorAll('.size').forEach((b) => {
      const x = data.variants.find((y) => y.options[0] === b.dataset.value);
      let tag = b.querySelector('.size-off');
      b.classList.toggle('sale', !!onSale(x));
      if (onSale(x)) {
        if (!tag) { tag = document.createElement('span'); tag.className = 'size-off'; tag.setAttribute('aria-hidden', 'true'); b.appendChild(tag); }
        tag.textContent = '\u2212' + Math.round((1 - x.price / x.compare) * 100) + '%';
      } else if (tag) tag.remove();
      // sizes selling on pre-order (Shopify "continue selling" at zero stock, the same rule PreOrder Globo uses)
      let pt = b.querySelector('.size-pre');
      const pre = !!(x && x.available && x.preorder);
      b.classList.toggle('pre', pre);
      if (pre) { if (!pt) { pt = document.createElement('span'); pt.className = 'size-pre'; pt.setAttribute('aria-hidden', 'true'); b.appendChild(pt); } pt.textContent = tr('pre_order', 'Pre-order'); }
      else if (pt) pt.remove();
    });
  }

  // spec card: every size, grouped (area rugs / runners / round), sale sizes marked; tap one to choose it
  function specSizes() {
    const box = document.querySelector('[data-sc-sizes]'); if (!box || groups.length !== 1) return;
    const seen = new Set();
    const list = data.variants.filter((v) => v.available && !seen.has(v.options[0]) && seen.add(v.options[0]))
      .map((v) => ({ v, r: rankOf(v.options[0]) }))
      .sort((a, b) => a.r[0] - b.r[0] || a.r[1] - b.r[1] || a.r[2] - b.r[2]);
    const names = [TT.grp_area || 'Area rugs', TT.grp_runner || 'Runners', TT.grp_round || 'Round', TT.grp_other || 'Other sizes'];
    const kinds = [...new Set(list.map((x) => x.r[0]))];
    const label = (s) => String(s).replace(/'/g, '\u2032').replace(/"/g, '\u2033').replace(/\s*x\s*/i, ' \u00d7 ');
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    box.querySelector('[data-sc-list]').innerHTML = kinds.map((k) => `<div class="sc-grp${kinds.length > 1 ? '' : ' solo'}">${kinds.length > 1 ? `<span class="sc-k">${names[k]}</span>` : ''}<div class="sc-chips">${
      list.filter((x) => x.r[0] === k).map(({ v }) => `<button type="button" class="sc-chip${onSale(v) ? ' sale' : ''}${v.available ? '' : ' oos'}" data-sc-v="${esc(v.options[0])}">${esc(label(v.options[0]))}</button>`).join('')
    }</div></div>`).join('');
    if (!list.length) return;
    box.querySelector('.sc-legend').hidden = !list.some((x) => onSale(x.v));
    box.hidden = false;
    box.addEventListener('click', (e) => {
      const c = e.target.closest('[data-sc-v]'); if (!c) return;
      const b = [...groups[0].querySelectorAll('.size')].find((y) => y.dataset.value === c.dataset.scV); if (!b) return;
      b.click();
      (root.querySelector('.pdp-sticky') || root).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function markAvailability() {
    // single-option products: strike through sizes that are sold out
    if (groups.length !== 1) return;
    groups[0].querySelectorAll('.size').forEach((b) => {
      const x = data.variants.find((y) => y.options[0] === b.dataset.value);
      b.classList.toggle('oos', !x || !x.available);
    });
  }

  function update(push) {
    const vid = $('rbVariantId'); if (vid && String(vid.value) !== String(current.id)) { vid.value = current.id; vid.dispatchEvent(new Event('change', { bubbles: true })); } // PreOrder Globo watches this input
    const price = $('price');
    if (price) price.innerHTML = current.compare > current.price ? `<s>${money(current.compare)}</s><span class="now is-sale">${money(current.price)}</span>` : `<span class="now">${money(current.price)}</span>`;
    const add = $('rbAdd');
    if (add) {
      add.disabled = !current.available;
      add.textContent = !current.available ? tr('sold_out', 'Sold out') : `${current.preorder ? tr('pre_order', 'Pre-order') : tr('add_to_bag', 'Add to bag')} · ${money(current.price)}`;
    }
    const note = $('preorderNote'); if (note) note.hidden = !current.preorder;
    // pre-order sizes only use the main Pre-order button, which adds to the bag (no second button that skips the bag)
    const bn = $('rbBuyNow'); if (bn) { bn.hidden = !current.available || !!current.preorder; bn.textContent = tr('buy_now', 'Buy now'); }
    const sku = $('rbSku'); if (sku) sku.textContent = current.sku || '';
    const ex = $('rbExact'); if (ex && current.exact && current.exact !== ' cm') ex.textContent = current.exact;
    groups.forEach((g, i) => {
      g.querySelectorAll('.size').forEach((b) => { const on = b.dataset.value === current.options[i]; b.classList.toggle('on', on); b.setAttribute('aria-checked', on); });
      const lab = root.querySelector(`[data-opt-name="${i}"]`); if (lab) lab.textContent = String(current.options[i]).replace(/'/g, '′');
    });
    if (push) { const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u); }
    guardAdd();
    filterGallery();
    padOffer();
    drawPlan();
  }

  groups.forEach((g, i) => g.addEventListener('click', (e) => {
    const b = e.target.closest('.size'); if (!b) return;
    const opts = current.options.slice(); opts[i] = b.dataset.value;
    current = findVariant(opts) || data.variants.find((x) => x.options[i] === b.dataset.value) || current;
    update(true);
  }));

  // ---------- gallery: only the photos that belong to the chosen size (area / runner / round ...) ----------
  const gal = $('gallery');
  let list = [];
  function filterGallery() {
    if (!gal) return;
    const btns = [...gal.querySelectorAll('button[data-media]')];
    let shown = btns;
    if (data.grouped && current.group) {
      const g = btns.filter((b) => b.dataset.group === String(current.group));
      if (g.length) shown = g;
    }
    btns.forEach((b) => { b.hidden = !shown.includes(b); });
    shown.forEach((b) => gal.appendChild(b));
    // real home video tile (rb-sku-video) stays third, after the first two photos of the chosen size
    const ugc = gal.querySelector('.pdp-ugc');
    if (ugc) gal.insertBefore(ugc, shown[2] || null);
    btns.filter((b) => !shown.includes(b)).forEach((b) => gal.appendChild(b));
    shown.forEach((b, i) => { b.dataset.i = i; });
    list = shown.map((b) => b.dataset.src.replace(/([?&])width=\d+&?/, '$1'));
    const count = gal.querySelector('.pdp-count');
    if (count && shown[0]) { shown[0].appendChild(count); count.textContent = `1 / ${shown.length}`; }
    const first = shown[0] && shown[0].querySelector('img');
    if (first) { first.loading = 'eager'; }
    gal.scrollLeft = 0;
  }
  if (gal) {
    gal.addEventListener('click', (e) => { const b = e.target.closest('[data-i]'); if (b && U()) U().lb.open(list, +b.dataset.i); });
    // the first photo loads alone; the others follow once it has arrived, or as soon as the shopper swipes or picks a size
    let woke = false;
    const wakeAll = () => { if (woke) return; woke = true; gal.querySelectorAll('img[data-src]').forEach((i) => (window.RBWake ? window.RBWake(i) : (i.srcset = i.dataset.srcset || '', i.src = i.dataset.src))); };
    const firstImg = gal.querySelector('img:not([data-src])');
    if (firstImg && !firstImg.complete) { firstImg.addEventListener('load', () => setTimeout(wakeAll, 120), { once: true }); firstImg.addEventListener('error', wakeAll, { once: true }); setTimeout(wakeAll, 5000); } else setTimeout(wakeAll, 120);
    ['scroll', 'pointerdown', 'keydown'].forEach((ev) => gal.addEventListener(ev, wakeAll, { once: true, passive: true }));
    root.addEventListener('click', wakeAll, { once: true });
    setTimeout(() => { const v = gal.querySelector('button:not([hidden]) img'); if (v && v.dataset.src) wakeAll(); }, 0);
    gal.addEventListener('scroll', () => {
      const count = gal.querySelector('.pdp-count'); if (!count) return;
      const w = gal.firstElementChild ? gal.firstElementChild.getBoundingClientRect().width : 1;
      count.textContent = `${Math.min(list.length, Math.round(gal.scrollLeft / w) + 1)} / ${list.length}`;
    }, { passive: true });
  }

  // ---------- matching rug pad (largest HPAD that fits inside the chosen size) ----------
  let padChoice = null;
  function padOffer() {
    const box = $('padOffer'); if (!box || !U() || !U().bestPad) return;
    const P = window.RBCFG && window.RBCFG.pad;
    const sizeIdx = groups.findIndex((g) => g.hasAttribute('data-size-option'));
    const isPad = P && (data.handle === P.handle || /(^|-)[hm]pad(-|$)/i.test(data.handle || ''));
    padChoice = !isPad && sizeIdx >= 0 ? U().bestPad(current.options[sizeIdx]) : null;
    if (!padChoice) { box.hidden = true; return; }
    const padSize = U().fmtFt(U().dims(padChoice.v.title));
    $('padImg').src = P.image || '';
    $('padLine').textContent = `${padSize} · ${money(padChoice.v.price)} · ${tr('pad_for', 'for your {size} rug').replace('{size}', U().fmtFt(padChoice.rug))}`;
    $('padNote').textContent = padChoice.exact ? tr('pad_note_exact', 'Cut to the same size as your rug.') : tr('pad_note_near', 'Sits just inside the edges, and trims easily with scissors should you prefer a closer fit.');
    box.hidden = false;
    const why = $('padWhy'); if (why) why.hidden = !document.getElementById('why-pad');
  }

  // ---------- add to bag ----------
  const form = $('rbProductForm');
  if (form) form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!current.available || !U()) return;
    const rug = $('rugR');
    const from = rug && !$('planWrap').hidden ? { el: rug, src: planImg(), rotate: planShape.round ? 0 : 90 } : (gal && gal.querySelector('img'));
    const extra = padChoice && $('padAdd') && $('padAdd').checked ? [{ id: padChoice.v.id, quantity: 1 }] : null;
    U().addToBag(current.id, 1, from, current.preorder ? { 'Pre-order': 'Yes' } : null, extra);
  });

  // PreOrder Globo's "Email me when available" button: keep it right under the sold-out button
  const placeBis = () => { const g = document.querySelector('.gBackInStock-Button'), row = root.querySelector('.buy-row'); if (g && row && row.nextElementSibling !== g) row.after(g); };
  new MutationObserver(placeBis).observe(document.body, { childList: true, subtree: true });

  // PreOrder Globo restyles and relabels the add button on pre-order sizes; keep the theme's own look and wording
  // (Globo still handles the pre-order itself, the order tag and the back-in-stock emails)
  function guardAdd() {
    // during a sale event, show the event price (same as the Add to bag button; rb-events.js owns the rule)
    const shown = window.RBEV && window.RBEV.salePrice ? window.RBEV.salePrice(current.price, current.compare) : current.price;
    const want = !current.available ? tr('sold_out', 'Sold out') : `${current.preorder ? tr('pre_order', 'Pre-order') : tr('add_to_bag', 'Add to bag')} · ${money(shown)}`;
    root.querySelectorAll('.buy-row .gPreorderBtn').forEach((b) => { if (b.textContent.trim() !== want) b.textContent = want; });
  }
  { const row = root.querySelector('.buy-row'); if (row) new MutationObserver(guardAdd).observe(row, { childList: true, characterData: true, subtree: true }); }

  // "Add the rug pad" in the why-pad section ticks the pad offer and returns to the size picker
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-pad-pick]')) return;
    const cb = $('padAdd'), box = $('padOffer'); if (!cb || !box || box.hidden) return;
    if (!cb.checked) { cb.checked = true; cb.dispatchEvent(new Event('change', { bubbles: true })); }
    box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  });

  // the floating chat button steps aside on phones while the buy buttons are on screen, so it never covers them
  { const row = root.querySelector('.buy-row'); if (row && 'IntersectionObserver' in window) new IntersectionObserver((es) => es.forEach((e) => document.documentElement.classList.toggle('buyrow-on', e.isIntersecting))).observe(row); }

  // ---------- buy now: add this size (and the pad, if ticked) and go straight to checkout ----------
  const buyNow = $('rbBuyNow');
  if (buyNow) buyNow.addEventListener('click', async () => {
    if (!current.available || current.preorder) return;
    buyNow.disabled = true;
    const items = [{ id: current.id, quantity: 1, properties: current.preorder ? { 'Pre-order': 'Yes' } : {} }];
    if (padChoice && $('padAdd') && $('padAdd').checked) items.push({ id: padChoice.v.id, quantity: 1 });
    try {
      const r = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error('add');
      location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
    } catch (e) { buyNow.disabled = false; alert(tr('add_error', 'Sorry, that could not be added. Please try again.')); }
  });

  // the plan is folded away until asked for; opening it replays the rug growing in
  const fold = $('planFold');
  if (fold) fold.addEventListener('toggle', () => { if (fold.open) { shown = null; drawPlan(); } });

  // ---------- room plan: hardwood floor (colour picker), furniture, the rug drawn to scale from its top view ----------
  const plan = $('plan');
  const FLOORS = { 'light-oak': '#d6ba8c', 'natural-oak': '#bf8f60', 'white-oak': '#e3d3b8', 'grey-wash': '#b1a99d', 'walnut': '#7a5134', 'espresso': '#4a3326' };
  let floorKey = 'natural-oak';
  try { const f = localStorage.getItem('rb_floor'); if (FLOORS[f]) floorKey = f; } catch (e) {}
  let planShape = {};
  let shown = null, tweenId = 0, room = null;
  // the plan needs a straight-down photo of the rug in the right shape: a runner's narrow top view, otherwise the
  // product's first (flat) photo; a photo alt-tagged "top view" always wins; lifestyle or folded shots never do
  function planTop(v) {
    const M = data.media || [], sizeIdx = groups.findIndex((g) => g.hasAttribute('data-size-option'));
    const d = sizeIdx >= 0 ? dims(v.options[sizeIdx]) : null;
    if (!d || d.round || !M.length) return v.top || data.flat || '';
    const inGroup = (m) => !data.grouped || !v.group || m.g === String(v.group);
    const tagged = M.find((m) => m.tv && inGroup(m)); if (tagged) return tagged.u;
    const r = Math.min(d.w, d.h) / Math.max(d.w, d.h);
    if (r <= 0.45) { const n = M.find((m) => inGroup(m) && m.ar <= 0.5) || M.find((m) => m.ar <= 0.5); return (n || M[0]).u; }
    if (M[0].ar >= 0.95 && M[1] && M[1].ar < 0.8) return M[1].u; // room photo first, top view second
    return M[0].ar > 0.45 && M[0].ar < 1 ? M[0].u : v.top || data.flat || '';
  }
  const planImg = () => planTop(current);
  // the plan's rug photo loads when the plan comes into view, not with the page
  let planSeen = !('IntersectionObserver' in window);
  const planHref = () => (planSeen ? planImg() : '');
  if (!planSeen && $('planWrap')) new IntersectionObserver((es, o) => { if (es.some((e) => e.isIntersecting)) { planSeen = true; o.disconnect(); const ri = $('rugImg'); if (ri) ri.setAttribute('href', planImg()); } }, { rootMargin: '300px 0px' }).observe($('planWrap'));
  const shade = (hex, amt) => { const n = parseInt(hex.slice(1), 16); const cl = (v) => Math.max(0, Math.min(255, v)); const r = cl((n >> 16) + amt), g = cl(((n >> 8) & 255) + amt), b = cl((n & 255) + amt); return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1); };

  // the room follows the rug: runners in a hallway (short ones in a kitchen), small rugs by the front door,
  // round rugs under a dining table, everything else in a living room — the same rooms as the Shop by Size guide
  function roomFor(d) {
    const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h);
    if (d.round) return S >= 5 ? { kind: 'dining', RW: Math.max(12, Math.ceil(S + 5)), RH: Math.max(10, Math.ceil(S + 4)) } : { kind: 'entry', RW: 9, RH: 7 };
    if (L / S >= 2.2) return L <= 8 ? { kind: 'kitchen', RW: Math.max(12, Math.ceil(L + 5)), RH: 10 } : { kind: 'hall', RW: Math.ceil(L + 4), RH: Math.max(5, Math.ceil(S + 3)) };
    if (S * L <= 16) return { kind: 'entry', RW: Math.max(9, Math.ceil(L + 5)), RH: Math.max(7, Math.ceil(S + 4)) };
    return { kind: 'living', RW: Math.max(18, Math.ceil(L + 4)), RH: Math.max(14, Math.ceil(S + 5)) };
  }

  function drawRoom(spec, d) {
    const K = window.RBPlan, pr = 'rb', { kind, RW, RH } = spec;
    const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h);
    const FT = Math.min(344 / RW, 262 / RH), W = RW * FT, H = RH * FT, OX = (360 - W) / 2, OY = 8;
    const X = (v) => OX + v * FT, Y = (v) => OY + v * FT;
    plan.setAttribute('viewBox', `0 0 360 ${Math.round(H + 16)}`);
    let cx = OX + W / 2, cy = OY + H / 2, under = '', over = '', walls = '', win = true;
    if (kind === 'living') {
      const sofaW = 8 * FT, sofaD = 3.1 * FT, sofaX = OX + (W - sofaW) / 2, sofaY = OY + H - sofaD - 0.35 * FT;
      cy = OY + (H - sofaD) / 2 + 0.6 * FT;
      over = K.chair(pr, X(2.1), cy, 2.9 * FT, 90) + K.sofa(pr, sofaX, sofaY, sofaW, sofaD) + K.coffeeTable(pr, cx, cy + 0.2 * FT, 4.2 * FT, 2 * FT) + K.plant(pr, X(RW - 1.3), Y(1.3), 1.3 * FT);
    } else if (kind === 'hall') {
      win = false;
      over = K.consoleTable(pr, X(RW * 0.35), Y(0.12), Math.min(4, RW * 0.2) * FT, 0.9 * FT) + K.plant(pr, X(RW - 0.8), Y(0.8), 0.7 * FT);
      walls = K.door('left', OX, OY, W, H, (H - 2.8 * FT) / 2, (H + 2.8 * FT) / 2, '#1d1b18', '#f8f5f0');
    } else if (kind === 'kitchen') {
      win = false;
      under = K.counter(pr, OX, OY, W, 2 * FT, true);
      cy = Y(2.6 + S / 2);
      const top = 2.6 + S + 1.8;
      if (RH - top >= 3.5) { const iw = Math.min(6, RW - 4) * FT; over = K.island(pr, cx - iw / 2, Y(top), iw, 3 * FT); }
      over += K.plant(pr, X(0.9), Y(RH - 0.9), 0.8 * FT);
    } else if (kind === 'entry') {
      win = false;
      cx = X(0.5 + L / 2);
      over = K.bench(pr, X(RW - 4.4), Y(0.25), 4 * FT, 1.3 * FT) + K.plant(pr, X(RW - 0.9), Y(RH - 0.9), 0.8 * FT);
      walls = K.door('left', OX, OY, W, H, (H - 3 * FT) / 2, (H + 3 * FT) / 2, '#1d1b18', '#f8f5f0');
    } else if (kind === 'dining') {
      const td = Math.max(3, Math.min(5.5, S - 3.5)) * FT, cs = 1.5 * FT;
      over = [0, 1, 2, 3].map((i) => {
        const a = i * Math.PI / 2 + Math.PI / 4, r = td / 2 + 0.9 * FT, x = cx + Math.cos(a) * r, y = cy + Math.sin(a) * r;
        return K.diningChair(pr, x, y, cs, (Math.atan2(-Math.cos(a), Math.sin(a)) * 180) / Math.PI);
      }).join('') + K.diningTable(pr, cx - td / 2, cy - td / 2, td, td, true) + K.plant(pr, X(RW - 1.1), Y(1.1), 1 * FT);
    }
    room = { RW, RH, FT, OX, OY, cx, cy, kind, key: `${kind}|${RW}|${RH}|${S}|${L}` };
    plan.innerHTML = `
      <defs>
        ${K.defs(pr, FT, floorKey)}
        <clipPath id="rugClip"><rect id="rugClipR"/><ellipse id="rugClipE"/></clipPath>
        <clipPath id="roomClip"><rect x="${OX}" y="${OY}" width="${W}" height="${H}"/></clipPath>
      </defs>
      <rect x="${OX - 3}" y="${OY - 3}" width="${W + 6}" height="${H + 6}" fill="#1d1b18"/>
      <g clip-path="url(#roomClip)">
        <rect x="${OX}" y="${OY}" width="${W}" height="${H}" fill="url(#rbFloor)"/>
        ${win ? `<path d="M${OX + W * 0.22} ${OY} L${OX + W * 0.52} ${OY} L${OX + W * 0.62} ${OY + H * 0.62} L${OX + W * 0.14} ${OY + H * 0.62} Z" fill="url(#rbSun)"/>` : ''}
        ${under}
        <g id="rugLayer">
          <rect id="rugShadowR" fill="#2b2620" filter="url(#rbRugShadow)"/>
          <ellipse id="rugShadowE" fill="#2b2620" filter="url(#rbRugShadow)"/>
          <g clip-path="url(#rugClip)"><image id="rugImg" href="${planHref()}" preserveAspectRatio="none"/></g>
        </g>
        ${over}
      </g>
      ${walls}
      ${win ? `<rect x="${OX + W * 0.22}" y="${OY - 3}" width="${W * 0.3}" height="3" fill="#dfe4e3"/><line x1="${OX + W * 0.22}" y1="${OY - 1.5}" x2="${OX + W * 0.52}" y2="${OY - 1.5}" stroke="#9aa3a3" stroke-width="0.6"/>` : ''}
      <g id="rugLblG"><rect id="rugLblBg" rx="8" fill="#f8f5f0" opacity=".92"/><text id="rugLbl" font-family="Instrument Sans, sans-serif" font-size="9" letter-spacing="1.3" fill="#1d1b18" text-anchor="middle"></text></g>
      <text x="${OX + W - 6}" y="${OY + H - 6}" font-family="Instrument Sans, sans-serif" font-size="7.5" letter-spacing="1.2" fill="#f8f5f0" text-anchor="end" opacity=".9">${(tr('room_word', 'Room')).toUpperCase()} ${RW}′ × ${RH}′</text>`;
    shown = null;
  }
  function applyPlan(w, h, cw) {
    const { cx, cy } = room, x = cx - w / 2, y = cy - h / 2;
    const ids = (n) => $(n);
    const R = ids('rugClipR'), E = ids('rugClipE'), SR = ids('rugShadowR'), SE = ids('rugShadowE'), im = ids('rugImg');
    const vis = Math.max(0, cw);
    if (planShape.round) {
      [R, SR].forEach((r) => r.setAttribute('width', 0));
      [E, SE].forEach((e) => { e.setAttribute('cx', cx); e.setAttribute('cy', cy); e.setAttribute('rx', vis / 2); e.setAttribute('ry', h / 2); });
      // round top views have white corners: draw a little larger and let the circle crop them away
      const k = 1.14; im.setAttribute('x', cx - w * k / 2); im.setAttribute('y', cy - h * k / 2); im.setAttribute('width', w * k); im.setAttribute('height', h * k); im.removeAttribute('transform');
    } else {
      [E, SE].forEach((e) => { e.setAttribute('rx', 0); e.setAttribute('ry', 0); });
      [R, SR].forEach((r) => { r.setAttribute('x', x); r.setAttribute('y', y); r.setAttribute('width', vis); r.setAttribute('height', h); });
      // top view is portrait: draw it portrait, 6% larger to crop any photo margin, then turn it into the footprint
      const k = 1.06; im.setAttribute('x', cx - h * k / 2); im.setAttribute('y', cy - w * k / 2); im.setAttribute('width', h * k); im.setAttribute('height', w * k);
      im.setAttribute('transform', `rotate(90 ${cx} ${cy})`);
    }
    const L = ids('rugLbl'), bg = ids('rugLblBg'), inside = room.kind === 'hall' || room.kind === 'kitchen' || y - 17 < room.OY + 2, ly = inside ? cy + 3 : y - 7;
    L.setAttribute('x', cx); L.setAttribute('y', ly);
    const tw = (L.textContent.length * 5.6) + 14; bg.setAttribute('x', cx - tw / 2); bg.setAttribute('y', ly - 10); bg.setAttribute('width', tw); bg.setAttribute('height', 14);
  }
  // "See it in your room" reads the rug on screen: its top-view photo and real size
  window.RBRug = () => {
    const sizeIdx = groups.findIndex((g) => g.hasAttribute('data-size-option'));
    const h1 = document.querySelector('.pdp-head h1');
    return { img: planImg(), d: sizeIdx >= 0 ? dims(current.options[sizeIdx]) : null, label: sizeIdx >= 0 ? current.options[sizeIdx] : '', title: h1 ? h1.textContent.trim() : '' };
  };
  if (location.hash === '#room') setTimeout(() => { const b = document.querySelector('[data-room-open]'); if (b && !$('planWrap').hidden) b.click(); }, 600);
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-room-open]'); if (!b) return;
    if (window.RBRoom) { window.RBRoom.open(); return; }
    b.disabled = true; const s = document.createElement('script'); s.src = b.dataset.src;
    s.onload = () => { b.disabled = false; window.RBRoom && window.RBRoom.open(); }; s.onerror = () => { b.disabled = false; };
    document.head.appendChild(s);
  });

  function drawPlan() {
    const wrap = $('planWrap'); if (!wrap || !plan) return;
    const sizeIdx = groups.findIndex((g) => g.hasAttribute('data-size-option'));
    const d = sizeIdx >= 0 ? dims(current.options[sizeIdx]) : null;
    if (!d) { wrap.hidden = true; return; }
    wrap.hidden = false;
    const L = Math.max(d.w, d.h), S = Math.min(d.w, d.h);
    const spec = roomFor(d), key = `${spec.kind}|${spec.RW}|${spec.RH}|${S}|${L}`;
    if (!room || room.key !== key || room.floor !== floorKey) { drawRoom(spec, d); room.floor = floorKey; }
    planShape = { round: !!d.round };
    const to = { w: L * room.FT, h: S * room.FT };
    const ri = $('rugImg'); if (ri && planSeen && ri.getAttribute('href') !== planImg()) ri.setAttribute('href', planImg());
    $('rugLbl').textContent = d.round ? `${fmt(S)} ${tr('round', 'round')}` : `${fmt(S)} × ${fmt(L)}`;
    const sum = $('planSum'); if (sum) sum.textContent = $('rugLbl').textContent;
    const CAP = { living: tr('plan_caption', 'Shown in a {room} living room with an 8′ sofa'), hall: tr('plan_cap_hall', 'Shown in a {room} hallway'), kitchen: tr('plan_cap_kitchen', 'Shown in a {room} kitchen'), entry: tr('plan_cap_entry', 'Shown by the front door, in a {room} entryway'), dining: tr('plan_cap_dining', 'Shown under a round table, in a {room} dining room') };
    $('planCap').textContent = CAP[spec.kind].replace('{room}', `${spec.RW}′ × ${spec.RH}′`);
    const from = shown && room.drawnKey === key ? shown : null; shown = to; room.drawnKey = key;
    if (reduce) { applyPlan(to.w, to.h, to.w); return; }
    const id = ++tweenId, dur = from ? 650 : 1300, ease = (t) => 1 - Math.pow(1 - t, 4);
    const run = () => {
      const t0 = performance.now();
      const step = (t) => {
        if (id !== tweenId) return;
        const k = ease(Math.min(1, (t - t0) / dur));
        if (from) { const w = from.w + (to.w - from.w) * k, h = from.h + (to.h - from.h) * k; applyPlan(w, h, w); }
        else applyPlan(to.w, to.h, to.w * k);
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!from) {
      applyPlan(to.w, to.h, 0);
      if (document.documentElement.classList.contains('hold')) document.addEventListener('rb:ready', () => setTimeout(run, 500), { once: true });
      else setTimeout(run, 500);
    } else run();
  }
  // floor colour picker
  document.querySelectorAll('[data-floor]').forEach((b) => {
    b.classList.toggle('on', b.dataset.floor === floorKey);
    b.addEventListener('click', () => {
      floorKey = b.dataset.floor; try { localStorage.setItem('rb_floor', floorKey); } catch (e) {}
      document.querySelectorAll('[data-floor]').forEach((o) => o.classList.toggle('on', o === b));
      const lab = document.getElementById('floorName'); if (lab) lab.textContent = b.title;
      room = null; shown = null; drawPlan();
    });
  });

  // remember this rug for "Recently viewed" (kept only in this shopper's browser)
  try {
    const key = 'rb_recent'; const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== data.handle);
    list.unshift(data.handle); localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
  } catch (e) { /* private mode: skip */ }

  markAvailability();
  markSale();
  specSizes();
  update(false);
})();
